module.exports = __webpack_public_path__ + "media/application/images/2018/icon-loading-287cd8d58a97c3b6497b891fe878d899.png";